import { render, staticRenderFns } from "./ColorModule.vue?vue&type=template&id=5fe54448&scoped=true"
import script from "./ColorModule.vue?vue&type=script&lang=ts"
export * from "./ColorModule.vue?vue&type=script&lang=ts"
import style0 from "./ColorModule.vue?vue&type=style&index=0&id=5fe54448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe54448",
  null
  
)

export default component.exports